<script lang="typescript">
    export let name: string;
    export let image: string;
    // export let baseHeightClass: string;
</script>

<div class="container h-auto">
    <img
        type="image/svg+xml"
        src={image}
        class="w-auto h-24 mx-auto mt-4 xl:mt-0"
        alt="contact lens option"
    />
    <span class="block my-2 text-xl font-medium text-center">
        {@html name}
    </span>
</div>

<style>
    .container {
        @apply items-center xl:items-start;
        @apply w-full flex-shrink-0;
        max-width: 21rem;
    }

    @media (min-width: 1280px) {
        .container {
            width: 21rem;
        }
    }
</style>
